import { compose, isEqual, isNil, toNumber } from 'lodash/fp';
import { formValueSelector } from 'redux-form';
import { ResourceCategoryType } from '@mews-commander/legacy-data-structures';
import { NEW_CHAIN_VALUE, ENTERPRISE_BUILDER_JSON_INDENT } from '../constants';

export const hasParentResourceSelectedByForm = (state: $TSFixMe, { form }: $TSFixMe) =>
    // @ts-expect-error $TSFixMeError: Expected 1 arguments, but got 2.
    compose(isEqual(ResourceCategoryType.Dorm.name), formValueSelector(form))(state, 'resourceCategoryType');

export const createJSONUrl = (json: $TSFixMe) =>
    window.URL.createObjectURL(
        new window.Blob([json], {
            type: 'text/json;encoding:utf-8',
        })
    );

export const parseNonNullValueToNumber = (value: $TSFixMe) => (!isNil(value) ? toNumber(value) : null);

export const isNewChain = isEqual(NEW_CHAIN_VALUE);

export const stringifyJSONData = (data: $TSFixMe) => JSON.stringify(data, null, ENTERPRISE_BUILDER_JSON_INDENT);

export const generateUnique32Integer = () => Math.floor((new Date().getTime() / 1000) * Math.random());
